import LanguagesTableTable from "./languages-table";

export default LanguagesTableTable;
